import { render, staticRenderFns } from "./volumes-modal.vue?vue&type=template&id=def8e306&scoped=true&"
import script from "./volumes-modal.vue?vue&type=script&lang=js&"
export * from "./volumes-modal.vue?vue&type=script&lang=js&"
import style0 from "./volumes-modal.vue?vue&type=style&index=0&id=def8e306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def8e306",
  null
  
)

export default component.exports